import { toast } from "react-toastify";
import React, { useEffect, useState, useRef } from "react";
import Modal from "@/app/core/layouts/main/components/Modal";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { Message } from "@/app/core/util/messages/GeralMessages";
import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import { CompanyController } from "@/app/core/base/controllers/CompanyController";
import CompanySearch from "@/app/core/layouts/main-components/input/CompanySearch";
import { CompanyHelper } from "@/app/core/util/helpers/CompanyHelper";

export default function DeleteCompanyModal({ show, onHide, company }) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState({});
  const [complains, setComplains] = useState([]);
  const [newCompany, setNewCompany] = useState({});

  const inputFile = useRef(null);

  useEffect(() => {
    if (show && company && company.id) {
      setData(company);
      loadInfos();
    } else {
      setData({});
    }
  }, [show]);

  async function loadInfos() {
    let res = await ComplainController.ListByCompany(company.id);
    console.log("B.O.", res);
    for(let s of res){
      const response = await Promise.all([
          AccountController.GetUser(s.userId)
      ]);
      s.user = response[0];
      s.company = company;
  }
    setComplains(res);
  }

  async function save() {
    let oldComplains = complains;
    if(company.id === undefined){
      toast.error(Message.PendingData);
    }else{
      for(let s of oldComplains){
        s.companyId = newCompany.id;
        ComplainController.Update(s);
      }
      let oldCompany = company;
      oldCompany.status = CompanyHelper.Status.Deleted;
      await CompanyController.Update(oldCompany);
      onHide();
    }
  }

  async function selectCompany(cp){
    setNewCompany(cp)
  }

  return (
    <Modal
      title="Deseja realmente excluir essa empresa?"
      show={show}
      onHide={onHide}
      isLoading={loading}
      onSubmit={() => save()}>
        
        <div className="content-heading">
            {complains && complains.length} Reclamações dentro dessa empresa<br/>
            Selecione para qual empresa devemos migrar essas Reclamações
        </div>
        {show && <CompanySearch onFullSelection={item => selectCompany(item)} hideRegister={true}/>}

    </Modal>
  );
}
